export const environment = {
  production: false,
  apiUrl: "https://api-stg.alaga.ph/",
  // apiUrl: "http://127.0.0.1:8000/",
  watermark: 'DEVELOPMENT',
  watermarkID: 'NOT VALID',
  watermarkMode: 'center', // 'repeat' or 'center'
  watermarkOpacity: 0.05,
  watermarkSize: '6.5rem',
  watermarkGap: 80,
  captchaKey: '6LfRtYYsAAAAAMtmu9b_RQ5tgQN_8Ievj-7VD0IT',  
};
